var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('SiteHero',{attrs:{"msg":"Knowledge is power. Know your fertility."}}),_c('ImageGallery'),_c('WhySection'),_c('HowSection'),_c('Products'),_c('StarterServices'),_c('ScaleServices')],1)}
var staticRenderFns = []

export { render, staticRenderFns }